import { motion } from 'framer-motion';
import { skills } from '../constants';

const Skills = () => {
    return (
        <section id="skills" className="section bg-white/[0.02]">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-16 text-center"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">Technical Arsenal</h2>
                    <p className="text-gray-400 max-w-2xl mx-auto">
                        A curated list of technologies I use to build the future.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {Object.entries(skills).map(([category, items], catIndex) => (
                        <motion.div
                            key={category}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: catIndex * 0.1, duration: 0.6 }}
                            className="glass-panel p-6 border border-white/5 hover:border-primary-purple/30 transition-colors"
                        >
                            <h3 className="text-xl font-bold text-white mb-6 border-b border-white/10 pb-4">
                                {category}
                            </h3>
                            <div className="flex flex-wrap gap-3">
                                {items.map((skill, index) => (
                                    <span
                                        key={skill}
                                        className="text-sm text-gray-400 hover:text-primary-purple transition-colors cursor-default"
                                    >
                                        {skill}
                                    </span>
                                ))}
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Skills;
